var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.records)?_c('div',[(_vm.records)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',{staticClass:"card-title"},[_c('bold-words',{attrs:{"word":{
                    text:(_vm.records.length == 1)?'most popular event':'popular events'
                    }}})],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",class:{
                'col-12 col-md-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2':_vm.records.length == 2,
                'col-md-4 offset-md-4':_vm.records.length == 1,
                'col-12':_vm.records.length > 2,
            }},[_c('div',{staticClass:"row"},_vm._l((_vm.records),function(record,index){return _c('div',{staticClass:"col-12",class:{
                'col-md-6 col-lg-4 col-xl-3 remaining_0':
                    // is the length the same as the limit
                    _vm.records.length % _vm.upsell_limit === 0
                ,
                'col-md-12 remaining_1':
                    // does the result leave 1 e.g. len=4 % limit=3 = 1 remaining
                    _vm.records.length % _vm.upsell_limit === 1
               ,
                'col-md-6 remaining_2':
                    // does the result leave 2 e.g. len=5 % limit=3 = 2 remaining
                    _vm.records.length % _vm.upsell_limit === 2
                    ,
                    'col-md-4 remaining_0':
                    // does the result leave 2 e.g. len=5 % limit=3 = 2 remaining
                    _vm.records.length % _vm.upsell_limit > 2

            }},[_c('tileCard',{attrs:{"record":record,"records":_vm.records}})],1)}))])])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7184b2ae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/front/modules/upsellCardRow.vue
// module id = kVUX
// module chunks = 0